<template>
  <div>
    <!-- <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div class="alert-icon">
        <i class="fas fa-info text-primary"></i>
      </div>
      <div class="alert-text">
        Double clic sur <strong>Réservation</strong> pour voir le detail.
      </div>
    </div> -->
    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 mt-5">
            <h3 class="card-title align-items-start flex-column text-dark">
              <span class="font-weight-bolder text-dark"
                >Réservations programmées</span
              >
            </h3>
            <div class="card-toolbar"></div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0 mt-n3">
            <!--begin::Table-->

            <DxScheduler
              :data-source="dataSource"
              :groups="groups"
              :current-date="currentDate"
              :views="views"
              :height="600"
              :showAllDayPanel="false"
              :cross-scrolling-enabled="true"
              current-view="month"
              :editing="editing"
              :on-appointment-dbl-click="onAppointmentDblClick"
            >
              <DxResource
                :allow-multiple="false"
                :data-source="partners"
                field-expr="partner.guid"
                label="Prestataire"
                :use-color-as-default="true"
              />
            </DxScheduler>
            <br />
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { DxScheduler, DxResource } from "devextreme-vue/scheduler";

import RequestsService from "../../../services/requests.service";
import partnersService from "../../../services/partners.service";
import moment from "moment";

export default {
  name: "request-reservations",
  components: {
    DxScheduler,
    DxResource,
  },
  data() {
    return {
      views: [
        {
          type: "day",
          groupOrientation: 'vertical',
        },
        // {
        //   type: "week",
        //   groupOrientation: 'vertical',
        // },
        {
          type: "month",
          groupOrientation: 'vertical',
        },
      ],
      groups: ["partner.guid"],
      currentDate: new Date(),
      dataSource: [],
      partners: [],
      editing: {
        allowAdding: false,
        allowDeleting: false,
        allowUpdating: false,
        allowResizing: false,
        allowDragging: false,
      },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Demandes", route: "scheduledreservations" },
      { title: "Réservations programmées" },
    ]);

    // this.dataSource = createStore({
    //   key: "guid",
    //   loadUrl: `${ApiService.baseURL}coordinator/v1/requests/reservations`,
    //   onBeforeSend: DxHelper.onBeforeSend,
    //   onAjaxError: DxHelper.onAjaxError,
    // });

    this.getScheduledReservations();
    this.getPartners();
  },
  methods: {
    getScheduledReservations: function () {
      RequestsService.getScheduledReservations().then((result) => {
        for (let i = 0; i < result.data.length; i++) {
          result.data[i].startDate = new Date(result.data[i].dateUtc);
          result.data[i].endDate = moment(result.data[i].dateUtc)
            .add(30, "m")
            .toDate();

          result.data[i].text = result.data[i].requestedBy.userName;
        }
        this.dataSource = result.data;
      });
    },
    getPartners: function () {
      partnersService.getPartners().then((result) => {
        for (let i = 0; i < result.data.length; i++) {
          result.data[i].id = result.data[i].guid;
          result.data[i].text = result.data[i].userName;
          
        }

        this.partners = result.data;
      });
    },
    onAppointmentDblClick(e) {
      this.$router.push({
        name: "requests-detail",
        params: { guid: e.appointmentData.guid },
      });
      e.cancel = true;
    },
    refresh() {
      this.getRequestsCount();
      this.dataGridInstance.refresh();
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
